import {
  ListProvidersOptions,
  Provider,
} from '@wix/public-editor-platform-interfaces';
import { PrivateAPINamespace } from '../PrivateAPINamespace';
import {
  createEditorPlatformPrivateAPIError,
  EditorPlatformPrivateAPIErrorCode,
} from '../../errors';

export class ProvidersNamespace extends PrivateAPINamespace {
  static readonly namespace = 'providers';

  public async attach(
    virtualManifestId: string,
    childPath: number[],
    providerIdentifier: string,
    data?: Object,
  ): Promise<void> {
    try {
      const api = this.ps.manifestServicesHost.getContextualManifestAPI(
        virtualManifestId,
        childPath,
      );

      const result = await api.query.attachProvider(providerIdentifier, data);
      if (result instanceof Error) {
        throw result;
      }
      return result;
    } catch (error) {
      console.error(error);
      throw createEditorPlatformPrivateAPIError(
        EditorPlatformPrivateAPIErrorCode.AttachProviderError,
        error instanceof Error
          ? error.message
          : 'attach provider operation failed',
      );
    }
  }

  public async detach(
    virtualManifestId: string,
    childPath: number[],
    providerIdentifier: string,
  ): Promise<void> {
    try {
      const api = this.ps.manifestServicesHost.getContextualManifestAPI(
        virtualManifestId,
        childPath,
      );

      const result = await api.query.detachProvider(providerIdentifier);
      if (result instanceof Error) {
        throw result;
      }
      return result;
    } catch (error) {
      console.error(error);
      throw createEditorPlatformPrivateAPIError(
        EditorPlatformPrivateAPIErrorCode.DetachProviderError,
        error instanceof Error
          ? error.message
          : 'detach provider operation failed',
      );
    }
  }

  public list(
    virtualManifestId: string,
    childPath: number[],
    options?: ListProvidersOptions,
  ): Provider[] {
    try {
      const api = this.ps.manifestServicesHost.getContextualManifestAPI(
        virtualManifestId,
        childPath,
      );

      const result = api.query.listProviders(options);
      if (result instanceof Error) {
        throw result;
      }
      return result;
    } catch (error) {
      console.error(error);
      throw createEditorPlatformPrivateAPIError(
        EditorPlatformPrivateAPIErrorCode.ListProvidersError,
        error instanceof Error
          ? error.message
          : 'list providers operation failed',
      );
    }
  }
}
